import { IDataControllerState } from './context';
import { isWindows } from './utils';
import { formatyyyymmdd } from './date';

async function windowsJsonSave(json: string, filename: string) {
  try {
    const Windows = (window as any).Windows;
    const savePicker = new Windows.Storage.Pickers.FileSavePicker();

    savePicker.suggestedStartLocation = Windows.Storage.Pickers.PickerLocationId.documentsLibrary;
    savePicker.fileTypeChoices.insert('JSON', ['.json']);
    savePicker.suggestedFileName = filename;

    const file = await savePicker.pickSaveFileAsync();

    if (!file) return;

    await Windows.Storage.CachedFileManager.deferUpdates(file);
    await Windows.Storage.FileIO.writeTextAsync(file, json, 'data:application/json;charset=utf-8');
    await Windows.Storage.CachedFileManager.completeUpdatesAsync(file);
  } catch (err) {
    console.log('Export Failed', err);
  }
}

function browserJsonSave(json: string, filename: string) {
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = `${filename}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportAllData(data: IDataControllerState) {
  const { tasks, projects, groups } = data;
  const filename = `eclipse-manager-export_${formatyyyymmdd(new Date(), '-')}`;

  const json = JSON.stringify({
    exportedAt: new Date().toISOString(),
    projects,
    tasks,
    groups,
  }, null, 2);

  if (isWindows()) {
    windowsJsonSave(json, filename);
  } else {
    browserJsonSave(json, filename);
  }
}
